import { useMutation } from '@tanstack/react-query';
import { updatePaymentMethod } from '@/lib/api/stripe';

export const usePaymentMethod = () => {
    const { mutateAsync, isPending } = useMutation({
        mutationFn: ({ paymentMethodId, customerId }: { paymentMethodId: string; customerId: string }) =>
            updatePaymentMethod(paymentMethodId, customerId),
    });

    return { mutateAsync, isPending };
};
